import { TabProps } from './types';
import { TabWrapper, Heading, HR, OptionDiv } from './styles';

const Tab: React.FC<TabProps> = ({
    items,
    selectedTab,
    color,
    onSelectTab,
}) => {
    return (
        <>
            <TabWrapper>
                {items.map((item: string) => {
                    return (
                        <OptionDiv
                            singleTab={items.length === 1}
                            key={item}
                            onClick={() => onSelectTab(item)}
                        >
                            <Heading
                                color={
                                    selectedTab === item ? '#040222' : '#5B5675'
                                }
                                borderColor={selectedTab === item ? color : ''}
                            >
                                {item}
                            </Heading>
                        </OptionDiv>
                    );
                })}
            </TabWrapper>
            <HR />
        </>
    );
};

export default Tab;
